/**
 * shell/Overlay.tsx —— 座位 `shell.overlay`（壳规范 §6 框架级浮层）。
 *
 * 规范逐字：层容器 **`pointer-events: none`**；条目自声明可交互区（**永不挡下方**）；
 *          条目按序排列互不遮挡；**不预置示例条目**（声明面 `overlay.preset_entries: []`）。
 * 纪律：本件不解释条目语义（徽章/toast/状态药丸由宿主投递）；条目自行 opt-in 交互区。
 *
 * U-W1 接线（任务书 §1.4）：浮层行为改由 `components/ShellOverlay` 承担
 *   （层穿透 `pointer-events:none` ＋ 条目 opt-in ＋ 按注册序互不遮挡）。
 *   本件只保留两件事：① **座位身份**（`seat-overlay`／`shell.overlay` 声明座位锚）；
 *   ② **空条目 ⇒ 整层不渲染**门禁（§6 不预置）。
 *   两类条目面并存：typed `items`（§2 座位表＝徽章/toast/状态药丸，直接进 ShellOverlay 条目面，
 *   opt-in 由条目自声明）＋ ReactNode `entries`（宿主自绘条目，样式层声明命中区）。
 */
import React from "react";
import { ShellOverlay, type ShellOverlayItem } from "../components/ShellOverlay";

export interface OverlayProps {
  /** 结构化条目按注册序（§2：徽章/toast/状态药丸；缺省 ⇒ 空层，不预置） */
  items?: ShellOverlayItem[];
  /** ReactNode 条目按注册序（宿主自绘条目，承源件默认 slot） */
  entries?: React.ReactNode[];
}

export function Overlay({ items, entries }: OverlayProps): React.ReactElement | null {
  const typed = items ?? [];
  const list = entries ?? [];
  if (typed.length === 0 && list.length === 0) return null;   // §6：不预置示例条目（空条目 ⇒ 不渲染）
  return (
    <div data-testid="seat-overlay" data-seat="shell.overlay" className="xg-overlay-seat">
      {/* U-W1：层容器/排序/opt-in 语义交 ShellOverlay（§6），本件仅承座位身份与空层门禁 */}
      <ShellOverlay items={typed}>
        {list.map((entry, index) => (
          <div className="xg-overlay-entry" data-testid={"overlay-entry-" + index} key={index}>
            {entry}
          </div>
        ))}
      </ShellOverlay>
    </div>
  );
}
